type ModelFamilyFields = {
  id: string
  displayName?: string
  apiModel?: string
  provider?: string
  displayOrder?: number
}

export const getModelFamily = (model: ModelFamilyFields): string => {
  // Identify the model itself before its host (e.g. Claude through OpenRouter).
  for (const value of [model.apiModel, model.id, model.displayName]) {
    const name = (value || '').toLowerCase()
    for (const family of ['Claude', 'DeepSeek', 'Gemini', 'GPT', 'Grok', 'Llama', 'Mistral', 'Qwen']) {
      if (name.includes(family.toLowerCase())) return family
    }
  }
  const provider = (model.provider || '').trim().toLowerCase()
  const providerFamilies: Record<string, string> = {
    anthropic: 'Claude',
    openai: 'GPT',
    google: 'Gemini',
    deepseek: 'DeepSeek',
    mistral: 'Mistral',
    xai: 'Grok',
  }
  return providerFamilies[provider] || provider || 'Other'
}

const customerPriority = (model: ModelFamilyFields): number => {
  const identities = [model.apiModel, model.id, model.displayName].map(value =>
    (value || '').toLowerCase().replace(/[^a-z0-9]/g, ''),
  )
  if (identities.some(value => /^(?:openai|chat)?gpt6sol$/.test(value))) return 0
  const family = getModelFamily(model)
  if (family === 'Claude') return 1
  if (family === 'Gemini') return 2
  if (identities.some(value => /^(?:openai|chat)?gpt6luna$/.test(value))) return 3
  return 4
}

export const compareModelsByFamily = (a: ModelFamilyFields, b: ModelFamilyFields): number => {
  const priority = customerPriority(a)
  const priorityOrder = priority - customerPriority(b)
  if (priorityOrder) return priorityOrder
  const options = { numeric: true, sensitivity: 'base', ignorePunctuation: true } as const
  const aName = a.displayName || a.id
  const bName = b.displayName || b.id
  // Keep newer Claude/Gemini variants first; alphabetize everything after Luna.
  const nameOrder = priority === 1 || priority === 2
    ? bName.localeCompare(aName, undefined, options)
    : aName.localeCompare(bName, undefined, options)
  return nameOrder || a.id.localeCompare(b.id, undefined, options)
}
